// extracted by mini-css-extract-plugin
export default {"Careercard":"Career_Careercard__Bn+aY","heading":"Career_heading__-URvx","cardWrapper":"Career_cardWrapper__UfTs-"};